'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable arrow-body-style */
import React from 'react'
import PrimaryButton from '@components/Home/PrimaryButton/Button'
import {
  TAP_BTN_EVENT,
  FIND_THE_RIGHT_PLAN,
  CTA_DEFAULT_ENDPOINT,
  FUNNEL_TYPE,
} from '@components/Product/ProductWidget/constants'
import { getClassNames } from '@helpers/productWidgetHelper'
import { ButtonType } from '@components/Home/PrimaryButton/buttonType'
import styles from './cta.module.scss'

const DynamicCta = ({
  productWidgetMainHeading,
  ProductWidgetSubHeading,
  disclaimer,
  widgetOptions,
  segmentEventCommonProperties,
  isBottomFloater = false,
}) => {
  const ctaTextWidget = widgetOptions?.ctaText || FIND_THE_RIGHT_PLAN
  const ctaUrlWidget = widgetOptions?.ctaUrl || CTA_DEFAULT_ENDPOINT

  const primaryButtonContainerClassNames = getClassNames([styles.primaryButton], {
    [styles.primaryButtonMarginOnFloater]: isBottomFloater,
  })

  const disclaimerContainerClassNames = getClassNames([styles.disclaimerDynamicCta], {
    [styles.disclaimerPaddingFloater]: isBottomFloater,
  })

  return (
    <div className={styles.buttonWrapperContainer}>
      {isBottomFloater && (
        <>
          <h2 className={styles.widgetMainHeading}>{productWidgetMainHeading}</h2>
          <p className={`${styles.widgetSubHeading}`}>{ProductWidgetSubHeading}</p>
        </>
      )}

      <PrimaryButton
        buttonType={ButtonType.GREEN}
        link={ctaUrlWidget}
        text={ctaTextWidget}
        segmentEventName={TAP_BTN_EVENT}
        segmentEventProps={{
          ...segmentEventCommonProperties,
          cta_text: ctaTextWidget,
          communication_pincode: '',
          funnel: FUNNEL_TYPE.ENTRY,
        }}
        additionalStyles={primaryButtonContainerClassNames}
      />
      {disclaimer && <p className={disclaimerContainerClassNames}>{disclaimer}</p>}
    </div>
  )
}

export default DynamicCta
